<mat-toolbar class="topbar horizontal-topbar b-b-1 gap-10">
  <div class="container">
    <div class="d-none d-sm-flex">
      <app-branding></app-branding>
    </div>

    <!-- Mobile Menu -->
    <button mat-icon-button (click)="toggleMobileNav.emit()"
      class="d-flex align-items-center justify-content-center d-lg-none m-x-2">
      <i-tabler name="menu-2" class="icon-20 d-flex"></i-tabler>
    </button>
    <!-- --------------------------------------------------------------- -->

    <div class="d-none d-lg-flex">
    </div>

    <span class="flex-1-auto"></span>

    <!-- Mobile Menu -->
    <button mat-icon-button (click)="toggleMobileFilterNav.emit()"
      class="d-flex d-lg-none justify-content-center m-x-2">
      <i-tabler name="grid-dots" class="icon-20 d-flex"></i-tabler>
    </button>

    <!-- --------------------------------------------------------------- -->
    <!-- light / dark icon -->
    <!-- --------------------------------------------------------------- -->
    @if(options.theme==='light'){
    <button mat-icon-button aria-label="lightdark" class="d-flex justify-content-center m-x-6"
      (click)="setlightDark('dark')" matTooltip="Cambiar a modo oscuro" matTooltipPosition="below">
      <i-tabler class="d-flex icon-22" [name]="'moon'"></i-tabler>
    </button>
    }@else{
    <button mat-icon-button aria-label="lightdark" class="d-flex justify-content-center m-x-6"
      (click)="setlightDark('light')" matTooltip="Cambiar a modo claro" matTooltipPosition="below">
      <i-tabler class="d-flex icon-22" [name]="'sun'"></i-tabler>
    </button>
    }

    <!-- --------------------------------------------------------------- -->
    <!-- Collpase bar -->
    <!-- --------------------------------------------------------------- -->
    <button mat-icon-button (click)="toggleCollpase()" class="d-flex d-lg-none justify-content-center">
      <i-tabler name="dots" class="icon-20 d-flex"></i-tabler>
    </button>
    @if(isCollapse){
    <div class="header-collpase p-y-10 p-x-15">
      <div class="d-flex align-items-center justify-content-center gap-10">
        <!-- --------------------------------------------------------------- -->
        <!-- Messages Dropdown -->
        <!-- --------------------------------------------------------------- -->
        <button mat-icon-button [matMenuTriggerFor]="msgMenu" aria-label="Messages">
          <i-tabler class="d-flex" name="message-2"></i-tabler>
          <div class="pulse">
            <span class="heartbit border-primary"></span>
            <span class="point bg-primary"></span>
          </div>
        </button>

        <!-- --------------------------------------------------------------- -->
        <!-- Profile Dropdown -->
        <!-- --------------------------------------------------------------- -->
        <button mat-fab extended color="inherit" [matMenuTriggerFor]="profileMenu" class="profile-btn"
          aria-label="Notifications">
          <div class="d-flex align-items-center gap-12">
            <img src="/assets/images/profile/user-placeholder.svg" class="rounded-circle object-cover" width="40" />
            <div class="d-none d-lg-flex text-left flex-col">
              <h5 class="f-s-16 f-w-600">{{ displayName }}</h5>
            </div>
          </div>
        </button>
      </div>
    </div>
    }

    <!-- --------------------------------------------------------------- -->
    <!-- Notifications Bell -->
    <!-- --------------------------------------------------------------- -->
    <button mat-icon-button [matMenuTriggerFor]="notificationsMenu" aria-label="Notifications"
      matTooltip="Notificaciones" matTooltipPosition="below"
      class="d-none d-lg-flex align-items-center justify-content-center position-relative m-x-2">
      <i-tabler class="d-flex" name="bell"></i-tabler>
      @if(notifications.length > 0) {
      <span class="notification-badge bg-primary">
        {{ notifications.length }}
      </span>
      }
    </button>
    <mat-menu #notificationsMenu="matMenu" xPosition="before" class="topbar-dd cardWithShadow">
      <div class="d-flex align-items-center justify-content-between p-x-32 p-y-16 b-b-1">
        <h6 class="f-s-16 f-w-600 m-0">Notificaciones</h6>
        <span class="badge bg-light-primary text-primary rounded f-s-12 f-w-600">{{ notifications.length }}
          nuevas</span>
      </div>
      <div class="p-x-16 p-y-8 notifications-scroll">
        <div *ngIf="notifications.length === 0" class="p-y-24 text-center text-muted">
          <p class="m-0">No hay notificaciones nuevas</p>
        </div>

        <div *ngFor="let notification of notifications"
          class="p-y-12 p-x-16 d-flex align-items-start rounded hover-bg-light-primary m-b-8 notification-row">
          <div class="notification-icon" style="flex-shrink: 0;">
            <i-tabler name="bell" class="icon-24 text-primary"></i-tabler>
          </div>
          <div class="m-l-12 notification-body" [class.cursor-pointer]="notification.kind === 1 && notification.externalId"
            (click)="notification.kind === 1 && notification.externalId ? onNotificationClick(notification) : null">
            <h6 class="f-s-14 f-w-600 m-0 notification-text" [ngClass]="{
                  'text-primary': notification.kind === 1 && notification.externalId,
                  'text-body': !(notification.kind === 1 && notification.externalId)
                }" [style.text-decoration]="notification.kind === 1 && notification.externalId ? 'underline' : 'none'"
              [style.text-decoration-style]="notification.kind === 1 && notification.externalId ? 'dotted' : 'none'">
              {{ formatNotificationDescription(notification.description) }}
            </h6>
            <p class="m-0 f-s-12 text-body-secondary">{{ notification.date | date:'dd/MM/yyyy HH:mm' }}</p>
          </div>
          <button mat-icon-button color="primary" class="flex-shrink-0"
            matTooltip="Marcar como leída" matTooltipPosition="left"
            (click)="markNotificationAsRead(notification.id)">
            <i-tabler name="check" class="icon-18 d-flex"></i-tabler>
          </button>
        </div>
      </div>
      <div class="p-y-12 p-x-32 b-t-1">
        <button mat-flat-button color="primary" class="w-100">
          Ver todas las notificaciones
        </button>
      </div>
    </mat-menu>

    <!-- --------------------------------------------------------------- -->
    <!-- Messages Dropdown -->
    <!-- --------------------------------------------------------------- -->
    <button mat-icon-button [matMenuTriggerFor]="msgMenu" aria-label="Messages"
      class="d-none d-lg-block align-items-center justify-content-center m-x-2">
      <i-tabler class="d-flex" name="message-2"></i-tabler>
      <div class="pulse">
        <span class="heartbit border-primary"></span>
        <span class="point bg-primary"></span>
      </div>
    </button>
    <mat-menu #msgMenu="matMenu" xPosition="before" class="topbar-dd cardWithShadow">
      <div class="d-flex align-items-center p-x-32 p-y-16">
        <h6 class="f-s-16 f-w-600 m-0">Messages</h6>
        <span class="m-l-16">
          <span class="bg-warning text-white p-x-8 p-y-4 f-w-500 rounded f-s-12">5 new</span>
        </span>
      </div>

      @for(notification of notifications; track notification.id) {
      <button mat-menu-item class="p-x-32 p-y-16" (click)="markNotificationAsRead(notification.id)">
        <div class="d-flex align-items-center">
          <div class="notification-icon">
            <i-tabler name="bell" class="icon-24 text-primary"></i-tabler>
          </div>
          <div class="m-l-16">
            <h5 class="f-s-14 f-w-600 m-0">
              {{ notification.description }}
            </h5>
            <span>{{ notification.date | date:'dd/MM/yyyy HH:mm' }}</span>
          </div>
        </div>
      </button>
      }
      @if(notifications.length === 0) {
      <div class="p-y-24 text-center text-muted">
        <p class="m-0">No hay notificaciones nuevas</p>
      </div>
      }

      <div class="p-y-12 p-x-32">
        <button mat-flat-button color="primary" class="w-100">
          See All Messages
        </button>
      </div>
    </mat-menu>

    <!-- --------------------------------------------------------------- -->
    <!-- profile Dropdown -->
    <!-- --------------------------------------------------------------- -->
    <button mat-fab extended color="inherit" [matMenuTriggerFor]="profileMenu" aria-label="Notifications"
      class="profile-btn d-none d-lg-flex align-items-center justify-content-center">
      <div class="d-flex align-items-center gap-12">
        <img [src]="userData?.img || '/assets/images/profile/user-placeholder.svg'" class="rounded-circle object-cover"
          width="40" />
        <div class="d-none d-lg-flex text-left flex-col">
          <h5 class="f-s-16 f-w-600">{{ displayName }}</h5>
        </div>
      </div>
    </button>
    <mat-menu #profileMenu="matMenu" xPosition="before" class="topbar-dd cardWithShadow">
      <div class="p-x-32 p-y-16 b-b-1">
        <h6 class="f-s-16 f-w-600 m-0">Usuario</h6>
        <div class="d-flex align-items-center gap-16 m-t-16">
          <img [src]="userData?.img || '/assets/images/profile/user-placeholder.svg'" class="rounded-circle" width="72"
            height="72" />
          <div>
            <h5 class="f-s-16 f-w-600 m-0">{{ displayName }}</h5>
            <span class="d-flex align-items-center text-body" *ngIf="userData?.email">
              <i-tabler name="mail" class="icon-15 m-r-4"></i-tabler>
              {{ userData.email }}
            </span>
          </div>
        </div>
      </div>
      <div class="p-x-32 p-y-16">
        <button mat-flat-button color="primary" class="w-100" (click)="onLogout()">
          Cerrar sesión
        </button>
      </div>
    </mat-menu>
  </div>
</mat-toolbar>